
import { Contact } from "@/models/base";
import { ContactAddress } from "@/models/base";
import { ReminderEmailTemplate } from "@/models/reminder-email-template";
import { ReminderTemplate } from "@/models/reminder-template";
import { DocumentLayoutInfo } from "@/utils/documents/layout-info";
import { ISelectItem } from "winfakt-vue-components";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import AppReminderSendModalCard from "./ReminderSendModalCard.vue";

export default FormLike.extend({
	props: {
		contact: {
			type: Object as () => Contact,
			required: true
		},
		templates: {
			type: Array as () => ReminderTemplate[],
			required: true
		},
		emailTemplates: {
			type: Array as () => ReminderEmailTemplate[],
			required: true
		},
		layouts: {
			type: Array as () => DocumentLayoutInfo[],
			required: true
		},
		selectedAddress: {
			type: Object as () => ContactAddress,
		},
		selectedEmailTemplate: {
			type: Object as () => ReminderEmailTemplate,
		},
		selectedTemplate: {
			type: Object as () => ReminderTemplate,
		},
		selectedLayout: {
			type: Object as () => DocumentLayoutInfo,
		},
		templateText: {
			type: String,
			required: true
		},
		downloadProgress: Number
	},
	computed: {
		templateItems(): ISelectItem<ReminderTemplate>[] {
			return this.templates.map(t => {
				return {
					text: t.getName(),
					value: t
				} as ISelectItem<ReminderTemplate>;
			});
		},
		emailTemplateItems(): ISelectItem<ReminderEmailTemplate>[] {
			return this.emailTemplates.map(t => {
				return {
					text: t.Name,
					value: t
				} as ISelectItem<ReminderEmailTemplate>;
			});
		},
		addressItems(): ISelectItem<ContactAddress>[] {
			if (!this.contact.Addresses) {
				return [];
			}
			return this.contact.Addresses.map(a => {
				return {
					text: a.toAddressString(),
					value: a
				};
			});
		},
		layoutItems(): ISelectItem<DocumentLayoutInfo>[] {
			return this.layouts.map(r => {
				return {
					text: r.Name,
					value: r
				};
			});
		},
		contactName():string{
			return this.contact.getDisplayName();
		},
		inputsDisabled():boolean {
			return this.downloadProgress !== undefined;
		},
		showProgress():boolean {
			return this.downloadProgress !== undefined;
		}
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		downloadDocument() {
			this.$emit("download-document");
		},
		printDocument() {
			this.$emit("print-document");
		}
	},
	components: {
		AppReminderSendModalCard
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
